// eslint-disable-next-line no-redeclare,no-unused-vars
function getScreenHeight() {
  return $(window).height();
}

// eslint-disable-next-line no-redeclare,no-unused-vars
function getScreenWidth() {
  return $(window).width();
}
